'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.childrenPropType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable import/prefer-default-export */


var childrenPropType = exports.childrenPropType = _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]);